export default __webpack_public_path__ + "static/media/birthday-bonus-ico.ade897f8.svg";